module.exports = __webpack_public_path__ + "static/media/SingleCoupon_brand.31c5b38c.png";